/**
 * Organization → Audit log (Figma 1695:3690): one page of a company's audit entries, served by
 * the CDK v2-paidol Lambda. Primary admins of the company and support users (server-side
 * assert_admin). Values are JSON-encoded as recorded: cents for credit limits, E.164 for phones.
 * SEE-1475: `details` is a transaction workflow entry's snapshot; with a transactionId the query
 * returns that transaction's history. A workflow download (`all`) comes a page at a time:
 * pass `nextToken` back until it is null.
 */
export const listAuditLogEventsQuery = /* GraphQL */ `
  query ListAuditLogEvents($input: ListAuditLogEventsInput!) {
    listAuditLogEvents(input: $input) {
      totalCount
      nextToken
      items {
        id
        timestamp
        eventName
        category
        originatorUserId
        originatorName
        subjectName
        oldValue
        newValue
        details
      }
    }
  }
`;
